import AuthState from './auth/auth.state';
import CallState from './call/call.state';
import UserState from './user/user.state';
import AppState from './app/app.state';
import ContactState from './contact/contact.state';
import CallLogState from './callLog/callLog.state';
import GlobalState from './global/global.state';
import { AgentsState } from './agents/agents.state';
import SettingsState from './settings/settings.state';
import MetricsState from './metrics/metrics.state';
import { QAState } from './qa/qa.state';
import { ChatState } from './chat/chat.state';
import { TasksState } from './tasks/tasks.state';
import InternalMessagingState from './internal-messaging/internal-messaging.state';
import AnnouncementsState from './announcement/announcement.state';
import CaseState from './case/case.state';
import { IDirectoryState } from './directory/directory.state';
import CampaignManagementState from './campaignManagement/campaignManagement.state';
import ICustomMessagingState from './customMessaging/customMessaging.state';
import QueuedTasksState from './queuedTasks/queuedTasks.state';
import NotificationState from './notification/notification.state';
import WebHIDState from './webHID/webHID.state';
import KendraPluginState from './kendraPlugin/kendraPlugin.state';
import AgentsAssistanceState from './agentsAssistance/agentsAssistance.state';
import IContactHistoryState from './contactHistory/contactHistory.state';
import IChannelSettingsState from './channelSettings/state';
import IContactSearchState from './contactSearch/contactSearch.state';
import WebsocketState from './websocket/websocket.state';
import WebsocketCompanionState from './websocketCompanion/websocketCompanion.state';

export default interface RootState {
    auth: AuthState;
    call: CallState | null;
    chat: ChatState;
    user: UserState;
    app: AppState;
    contact: ContactState | null;
    contacts: ContactState[] | [];
    callLog: CallLogState;
    global: GlobalState;
    agents: AgentsState;
    settings: SettingsState;
    metrics: MetricsState;
    qa: QAState;
    internalMessaging: InternalMessagingState;
    announcements: AnnouncementsState;
    case: CaseState;
    directory: IDirectoryState;
    campaignManagement: CampaignManagementState;
    tasks: TasksState;
    customMessaging: ICustomMessagingState;
    queuedTasks: QueuedTasksState;
    notification: NotificationState;
    webHIDState: WebHIDState;
    kendraPlugin: KendraPluginState;
    agentsAssistance: AgentsAssistanceState;
    contactHistory: IContactHistoryState[];
    channelSettings: IChannelSettingsState;
    contactSearch: IContactSearchState;
    websocket: WebsocketState;
    websocketCompanion: WebsocketCompanionState;
}

export enum LoadingStates {
    LOADING,
    LOADED,
    ERROR,
    NOT_FOUND,
}
